export default __webpack_public_path__ + "static/s4p-banner-transparent-b5e693379afbc78101f131bb88841708.png";